/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class KanbanControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation kanbanControllerFindDayIe
   */
  static readonly KanbanControllerFindDayIePath = '/kanban/findDayIe';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findDayIe()` instead.
   *
   * This method doesn't expect any request body.
   */
  findDayIe$Response(params: {
    day: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, KanbanControllerService.KanbanControllerFindDayIePath, 'get');
    if (params) {
      rb.query('day', params.day, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findDayIe$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findDayIe(params: {
    day: string;
    context?: HttpContext
  }
): Observable<{
}> {

    return this.findDayIe$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation kanbanControllerFormNumbers
   */
  static readonly KanbanControllerFormNumbersPath = '/kanban/formNumbers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formNumbers()` instead.
   *
   * This method doesn't expect any request body.
   */
  formNumbers$Response(params: {
    day: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, KanbanControllerService.KanbanControllerFormNumbersPath, 'get');
    if (params) {
      rb.query('day', params.day, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `formNumbers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  formNumbers(params: {
    day: string;
    context?: HttpContext
  }
): Observable<{
}> {

    return this.formNumbers$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation kanbanControllerForms
   */
  static readonly KanbanControllerFormsPath = '/kanban/forms';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `forms()` instead.
   *
   * This method doesn't expect any request body.
   */
  forms$Response(params?: {
    startTime?: string;
    endTime?: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, KanbanControllerService.KanbanControllerFormsPath, 'get');
    if (params) {
      rb.query('startTime', params.startTime, {});
      rb.query('endTime', params.endTime, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `forms$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  forms(params?: {
    startTime?: string;
    endTime?: string;
    context?: HttpContext
  }
): Observable<{
}> {

    return this.forms$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation kanbanControllerFindData
   */
  static readonly KanbanControllerFindDataPath = '/kanban/getDayForms';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findData()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findData$Response(params?: {
    type?: string;
    context?: HttpContext
    body?: {
}
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, KanbanControllerService.KanbanControllerFindDataPath, 'post');
    if (params) {
      rb.query('type', params.type, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findData$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findData(params?: {
    type?: string;
    context?: HttpContext
    body?: {
}
  }
): Observable<{
}> {

    return this.findData$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation kanbanControllerGetMonthForms
   */
  static readonly KanbanControllerGetMonthFormsPath = '/kanban/getMonthForms';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMonthForms()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMonthForms$Response(params?: {
    month?: string;
    signStep?: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, KanbanControllerService.KanbanControllerGetMonthFormsPath, 'post');
    if (params) {
      rb.query('month', params.month, {});
      rb.query('signStep', params.signStep, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getMonthForms$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMonthForms(params?: {
    month?: string;
    signStep?: number;
    context?: HttpContext
  }
): Observable<{
}> {

    return this.getMonthForms$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation kanbanControllerMonthNumbers
   */
  static readonly KanbanControllerMonthNumbersPath = '/kanban/monthNumbers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monthNumbers()` instead.
   *
   * This method doesn't expect any request body.
   */
  monthNumbers$Response(params: {
    currentYear: number;
    currentMonth: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, KanbanControllerService.KanbanControllerMonthNumbersPath, 'get');
    if (params) {
      rb.query('currentYear', params.currentYear, {});
      rb.query('currentMonth', params.currentMonth, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `monthNumbers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monthNumbers(params: {
    currentYear: number;
    currentMonth: string;
    context?: HttpContext
  }
): Observable<{
}> {

    return this.monthNumbers$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation kanbanControllerStandardForms
   */
  static readonly KanbanControllerStandardFormsPath = '/kanban/standardForms';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `standardForms()` instead.
   *
   * This method doesn't expect any request body.
   */
  standardForms$Response(params: {
    startTime: string;
    endTime: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, KanbanControllerService.KanbanControllerStandardFormsPath, 'get');
    if (params) {
      rb.query('startTime', params.startTime, {});
      rb.query('endTime', params.endTime, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `standardForms$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  standardForms(params: {
    startTime: string;
    endTime: string;
    context?: HttpContext
  }
): Observable<{
}> {

    return this.standardForms$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation kanbanControllerWaitSignNumbers
   */
  static readonly KanbanControllerWaitSignNumbersPath = '/kanban/waitSignNumbers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `waitSignNumbers()` instead.
   *
   * This method doesn't expect any request body.
   */
  waitSignNumbers$Response(params?: {
    month?: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, KanbanControllerService.KanbanControllerWaitSignNumbersPath, 'get');
    if (params) {
      rb.query('month', params.month, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `waitSignNumbers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  waitSignNumbers(params?: {
    month?: string;
    context?: HttpContext
  }
): Observable<{
}> {

    return this.waitSignNumbers$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

}
